import ServicesList from './_ServicesList';

export default ServicesList;
